<template>
    <div>
        <SelectInput
            v-model="value.select"
            :mode="mode"
            :options="options"
            :placeholder="placeholder"
            :appendToBody="appendToBody"
        />
        <NumInput
            v-if="isVisible"
            v-model="value.payDateXDays"
            class="mt-3"
            mode="edit"
            :controls="true"
        />
        <el-checkbox v-model="value.endMonth" class="mt-3">
            {{ $l10n.__('En fin de mois') }}
        </el-checkbox>
    </div>
</template>

<script>
import NumInput from 'vcomponents/inputs/NumInput.vue';
import SelectInput from 'vcomponents/inputs/SelectInput.vue';

export default {
    components: {
        NumInput,
        SelectInput,
    },
    props: {
        options: {
            type: Array,
            required: true,
            default: () => [],
        },
        mode: {
            type: String,
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
        modelValue: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        appendToBody: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:modelValue'],
    computed: {
        value: {
            get() {
                return this.modelValue;
            },
            set(newValue) {
                this.$emit('update:modelValue', newValue);
            },
        },
        isVisible: function () {
            let isVisible = false;
            this.options.forEach((option) => {
                if (this.value.select === option.value && option.syscode === 'xdays') {
                    isVisible = true;
                }
            });
            return isVisible;
        },
    },
};
</script>

<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;

.el-input-number span {
    background: $white;
    color: $gray-100;
}
</style>
